import { AuthenticationService } from './../services/authentication.service';
import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import * as _ from 'lodash';

@Directive({ selector: '[hasPerms]' })
export class HasPermsDirective {
    private granted = false;

    @Input() set hasPerms(perms: Array<string>) {
        if (!perms || perms.length==0) {
            this.granted = true;
        } else {
            const authUser = this.auth.getCurrentAuthUser();
            if (authUser.exists()) {
                this.granted = _.intersection(authUser.permissions, perms).length>0;
            } else {
                this.granted = false;
            }

        }
        if (this.granted) {
            this.viewContainer.createEmbeddedView(this.templateRef);
        } else {
            this.viewContainer.clear();
        }

        
      }

    constructor(
        private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef,
        private auth : AuthenticationService) { }



}